"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnrichAIRoutes = void 0;
const react_1 = __importDefault(require("react"));
const enrich_ai_dashboard_container_1 = require("./dashboard/enrich-ai-dashboard.container");
const enrich_ai_widgets_container_1 = require("./enrich-ai-widgets.container");
const feature_flags_1 = require("../feature-flags");
const router_1 = require("../router");
const context_1 = require("./context");
const task_view_1 = require("./hlqa/task-view");
const strategy_matrix_1 = __importDefault(require("./strategy-matrix/strategy-matrix"));
const getEnrichAIRoutes = (featureFlagsService) => {
    const isDashboardEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.EnrichAIDashboard);
    const isStrategyMatrixEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.StrategyMatrix);
    let routeProps = [{
            element: (react_1.default.createElement(context_1.ProductTreeNodeReaggregationStatusProvider, null, react_1.default.createElement(enrich_ai_widgets_container_1.EnrichAIWidgetsContainer, null))),
            path: router_1.EnrichSection.Workspace,
        }];
    if (isDashboardEnabled) {
        routeProps = routeProps.concat([
            {
                element: react_1.default.createElement(enrich_ai_dashboard_container_1.EnrichAIDashboardContainer, null),
                index: true,
            },
            {
                path: router_1.EnrichSection.HLQATaskView,
                element: react_1.default.createElement(task_view_1.EnrichAIHLQATaskView, null),
            },
        ]);
    }
    if (isStrategyMatrixEnabled) {
        routeProps.push({
            path: router_1.EnrichSection.StrategyMatrix,
            element: react_1.default.createElement(strategy_matrix_1.default, null),
        });
    }
    return routeProps;
};
exports.getEnrichAIRoutes = getEnrichAIRoutes;
